import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import store from "./store";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  setInteractionMode
} from "vee-validate";
import { required, min_value, max_value, email } from "vee-validate/dist/rules";
import VueGtm from "vue-gtm";

import { languages } from './i18n/index.js';

Vue.use(VueI18n);

const messages =Object.assign(languages);
var i18n = new VueI18n({
  locale: store.state.culture,
  fallbackLocale: store.state.culture,
  messages
})

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

// VeeValidate options
extend("email", email);
extend("min_value", min_value);
extend("max_value", max_value);
extend("required", {
  ...required,
  message: i18n.t('validate.fieldRequired')
});

extend("email", {
  ...email,
  message: i18n.t('validate.emailNotValid')
});

setInteractionMode("lazy");

Vue.use(VueGtm, {
  id: "GTM-PXBRFDG",
  enabled: true,
  debug: true,
  loadScript: true
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  store,
  i18n
}).$mount("#app");
